<div class="vc-modal__title sizeGuide__title">{{ guideTitle }}</div>

<div class="vc-modal__content sizeGuide__modalContent">
  <div class="sizeGuide__description" i18n="@@SIZE_GUIDE.POPIN.SG_POPIN_DESCRIPTION">
    The indicated size has been provided by the seller. This is the size that appears on the item. Vestiaire Collective
    suggests the following conversion:
  </div>

  <div *ngIf="guide.length > 0" class="sizeGuide__table">
    <div class="sizeGuide__table__row">
      <div *ngFor="let keyLabel of guideKeys" class="sizeGuide__table__cell header">{{ keyLabel }}</div>
    </div>

    <div
      *ngFor="let row of guide; let i = index"
      class="sizeGuide__table__row"
      [ngClass]="{'highlight-row': size == row[standard]}"
    >
      <div
        *ngFor="let keyLabel of guideKeys"
        class="sizeGuide__table__cell"
        [ngClass]="{'highlight-cell': keyLabel == standard && size == row[keyLabel]}"
      >
        {{ row[keyLabel] }}
      </div>
    </div>
  </div>
</div>
